import 'firebase/firestore';
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';

export default {
  name: 'FamilyEngagementBundle',
  components: { ConfirmDlg },
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null,
    facilityCopy: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    isFacilityHasCareAPI() {
      return this.$store.state.facilityModule.isFacilityHasCareAPI;
    },
    familyBundle: {
      get() {
        return (
          this.communicationCategory &&
          this.dailyCareCategory &&
          this.familyOtherCategory &&
          this.surveyCategory
        );
      }
    },
    communicationCategory: {
      get() {
        return (
          (this.facility.familyChatEnabled ?? true) &&
          (this.facility.scheduledCallsEnabled ?? true) &&
          (this.facility.residentCanTakePhoto ?? true) &&
          (this.facility.isResidentChat ?? true) &&
          (this.facility.isEnableFamilyNewsletter ?? true) &&
          (this.facility.isEnableFamilyNewsletter ?? true)
        );
      }
    },
    dailyCareCategory: {
      get() {
        return (
          (this.facility.isCarePlan ?? true) &&
          (!this.isFacilityHasCareAPI || (
            (this.facility.isEnableCareTab ?? true) &&
            (this.facility.isCareSummary ?? true) &&
            (this.facility.isDailyPlan ?? true) &&
            (this.facility.isDailyCare ?? true) &&
            (this.facility.isMessenger ?? true) &&
            (this.facility.isSharedPhotoGallery ?? true)
          ))
        );
      }
    },
    familyOtherCategory: {
      get() {
        return (
          (this.facility.isStaffCanLogInOnBehalfOfResident ?? true) &&
          (this.facility.isEnabledStaffAppNotificationsForAllResidents ?? true) &&
          (this.facility.isDisplayBirthdaysOnMyHub ?? true) &&
          (this.facility.canInviteFamilyMembers ?? true) &&
          (this.facility.isEnableResidentOwnDevice ?? true) &&
          (this.facility.isEnableResidentMultipleDevices ?? true) &&
          (this.facility.isEnableStaffAppNotifications ?? true) &&
          (this.facility.isEnabledResidentWingVisibleForOtherResidents ?? true) &&
          (this.facility.isStaffHubDashboard ?? true) &&
          (this.facility.isStaffHubResidents ?? true) &&
          (this.facility.isStaffHubContentManagerGallery ?? true) &&
          (this.facility.isStaffHubDocuments ?? true) &&
          (this.isFacilityHasCareAPI ? (this.facility.isEnableADT ?? true) : true) &&
          (!this.facility.isEnableADT || (
            (this.facility.isEnableCSVImportForResidents ?? true) &&
            (this.facility.isEnableManuallyAddDeleteResidents ?? true)
          ))
        );
      }
    },
    surveyCategory: {
      get() {
        return (
          this.facility.isStaffHubSurveys ?? true
        );
      }
    },
  },
  watch: {
    familyBundle() {
      this.$emit('send-bundle-value', this.familyBundle)
    }
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.familyBundle)
    },
    familyBundleUpdate(value) {
      this.communicationCategory = value;
      this.dailyCareCategory = value;
      this.familyOtherCategory = value;
      this.surveyCategory = value;
      this.communicationCategoryUpdate(value);
      this.dailyCareCategoryUpdate(value);
      this.familyOtherCategoryUpdate(value);
      this.surveyCategoryUpdate(value);
    },
    communicationCategoryUpdate(value) {
      this.facility.familyChatEnabled = value;
      this.facility.scheduledCallsEnabled = value;
      this.facility.residentCanTakePhoto = value;
      this.facility.isResidentChat = value;
      this.facility.isEnableFamilyNewsletter = value;
      this.facility.canStaffMessageFamily = value;
    },
    dailyCareCategoryUpdate(value) {
      this.facility.isCarePlan = value;
      if(this.isFacilityHasCareAPI) {
        this.facility.isEnableCareTab = value;
        this.facility.isCareSummary = value;
        this.facility.isDailyPlan = value;
        this.facility.isDailyCare = value;
        this.facility.isMessenger = value;
        this.facility.isSharedPhotoGallery = value;
      }
    },
    familyOtherCategoryUpdate(value) {
      this.facility.isStaffCanLogInOnBehalfOfResident = value;
      this.facility.isEnabledStaffAppNotificationsForAllResidents = value;
      this.facility.isDisplayBirthdaysOnMyHub = value;
      this.facility.canInviteFamilyMembers = value;
      this.facility.isEnableResidentOwnDevice = value;
      this.facility.isEnableResidentMultipleDevices = value;
      this.facility.isEnableStaffAppNotifications = value;
      this.facility.isEnabledResidentWingVisibleForOtherResidents = value;
      this.facility.isStaffHubDashboard = value;
      this.facility.isStaffHubResidents = value;
      this.facility.isStaffHubContentManagerGallery = value;
      this.facility.isStaffHubDocuments = value;

      if(this.isFacilityHasCareAPI) {
        this.facility.isEnableADT = value;
      }

      if(!this.facility.isEnableADT) {
        this.facility.isEnableCSVImportForResidents = value;
        this.facility.isEnableManuallyAddDeleteResidents = value;
      }
    },
    surveyCategoryUpdate(value) {
      this.facility.isStaffHubSurveys = value;
    },
    onIsEnableADTChange(value) {
      if(value === true){
        this.facility.isEnableCSVImportForResidents = false;
        this.facility.isEnableManuallyAddDeleteResidents = false;
      }
    },
    onIsStaffCanLogInOnBehalfOfResidentChange(value) {

      if(this.facilityCopy.isStaffCanLogInOnBehalfOfResident === value){
        return;
      }

      if (value === true) {
        this.$refs.confirmationModal
          .open(null, this.$t('Settings.FacilitySettings.StaffCanLogInOnBehalfOfResidentsPopUp'), false, "", null, null)
          .then(response => {
            if (response && response.agree) {
              this.facility.isStaffCanLogInOnBehalfOfResident = true
            }
            else{
              this.facility.isStaffCanLogInOnBehalfOfResident = false
            }
          })
      }
      else if (value === false) {
        this.$refs.confirmationModal
          .open(null, this.$t('Settings.FacilitySettings.OnDisableStaffCanLogInOnBehalfOfResidentsPopUp'), false, "", null, null)
          .then(response => {
            if (response && response.agree) {
              this.facility.isStaffCanLogInOnBehalfOfResident = false
            }
            else{
              this.facility.isStaffCanLogInOnBehalfOfResident = true
            }
          })
      }
    },
    onIsEnabledStaffAppNotificationsForAllResidentsChange(value) {

      if(this.facilityCopy.isEnabledStaffAppNotificationsForAllResidents === value){
        return;
      }

      if (value === true) {
        this.$refs.confirmationModal
          .open(null, this.$t('Settings.FacilitySettings.EnableStaffAppNotificationsForAllResidents'), false, "", null, null)
          .then(response => {
            if (response && response.agree) {
              this.facility.isEnabledStaffAppNotificationsForAllResidents = true
            }
            else{
              this.facility.isEnabledStaffAppNotificationsForAllResidents = false
            }
          })
          .catch(error => console.error(error))
      }
      else if (value === false) {
        this.$refs.confirmationModal
          .open(null, this.$t('Settings.FacilitySettings.DisableStaffAppNotificationsForAllResidents'), false, "", null, null)
          .then(response => {
            if (response && response.agree) {
              this.facility.isEnabledStaffAppNotificationsForAllResidents = false
            }
            else{
              this.facility.isEnabledStaffAppNotificationsForAllResidents = true
            }
          })
          .catch(error => console.error(error))
      }
    },
  }
};